if (!customElements.get('lang-selector-form')) {
    customElements.define(
        'lang-selector-form',
        class LangSelectorForm extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                    button: this.querySelector('button'),
                    panel: this.querySelector('.disclosure__list-wrapper'),
                };
                this.elements.button.addEventListener('click', this.openSelector.bind(this));
                this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
                this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        
                this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
            }
    
            hidePanel() {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }
    
            onContainerKeyUp(event) {
                if (event.code.toUpperCase() !== 'ESCAPE') return;
    
                if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
                this.hidePanel();
                event.stopPropagation();
                this.elements.button.focus();
            }
    
            onItemClick(event) {
                event.preventDefault();
                const form = this.querySelector('form');
                this.elements.input.value = event.currentTarget.dataset.value;
                if (form) form.submit();
            }
    
            openSelector() {
                this.elements.button.focus();
                this.elements.panel.toggleAttribute('hidden');
                this.elements.button.setAttribute(
                    'aria-expanded',
                    (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
                );
            }
    
            closeSelector(event) {
                const isChild =
                    this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
                if (!event.relatedTarget || !isChild) {
                    this.hidePanel();
                }
            }
        }
    );
}

const checkLang = () => {
    const langItems = document.querySelectorAll('lang-selector-form a');

    for (const lang of langItems) {
        lang.addEventListener('click', function (event) {
            event.preventDefault();

            langAttribute = lang.getAttribute('data-lang');

            window.location.href = window.location.origin + '/' + langAttribute;
        }, false);
    }

    const dutchItem = document.querySelectorAll('lang-selector-form .c-disclosure-clang span[data-lang="NL"]');
    const dutchLang = document.querySelectorAll('.js-disclosure-lang');

    if (dutchItem.length > 0) {
        for (const item of dutchLang) {
            item.style.display = 'block';

            const pathname = window.location.pathname;
            const langCode= pathname.split("/");
            
            if (langCode[1] == 'en') {
                const langCheck = document.querySelectorAll('.js-disclosure-lang span[data-name="en"]');
                
                for (const item of langCheck) {
                    item.style.display = 'block';
                }
            } else {
                const langCheck = document.querySelectorAll('.js-disclosure-lang span[data-name="nl"]');
                
                for (const item of langCheck) {
                    item.style.display = 'block';
                }
            }
        }
    }
};

window.addEventListener('DOMContentLoaded', () => {
    checkLang();
});
